import { memo, useCallback } from 'react';

import { Button, Flex, Text } from '@/components/core';
import { CloseIcon } from '@/components/icons';
import { StringColumnFilter, useInboxStore } from '@/store';

import { FilterCardSubType } from './FilterCard.tsx';

export type StringFilterCardProps = FilterCardSubType & {
  columns: string[];
  filter: StringColumnFilter;
};

const IStringFilterCard = ({ columns, filter, className, ...rest }: StringFilterCardProps) => {
  const updateFilter = useInboxStore((state) => state.updateFilter);
  const deleteFilter = useInboxStore((state) => state.deleteFilter);

  const deleteFilterValue = useCallback(
    (value: string) => {
      const newValues = filter.value?.filter((v) => v.id !== value) ?? [];
      if (newValues.length === 0) {
        deleteFilter(filter.id);
      } else {
        updateFilter(filter.id, { value: newValues });
      }
    },
    [deleteFilter, filter, updateFilter]
  );

  return (
    <div className="gap-sm flex items-center">
      {filter.value?.map((v) => (
        <Flex variant="primary" className="items-center rounded-md border border-gray-200 pl-3">
          <Text className="text-xs font-medium">{v.name}</Text>
          <Button onPress={() => deleteFilterValue(v.id)} variant="plain">
            <CloseIcon className="!text-primary-500 !size-3" />
          </Button>
        </Flex>
      ))}
    </div>
  );
};

export const StringFilterCard = memo(IStringFilterCard) as typeof IStringFilterCard;
